export default {

    POST_TRACKING_QUERY_REQUEST: 'POST_TRACKING_QUERY_REQUEST',
    POST_TRACKING_QUERY_SUCCESS: 'POST_TRACKING_QUERY_SUCCESS',
    POST_TRACKING_QUERY_FAILURE: 'POST_TRACKING_QUERY_FAILURE'

};
